import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";

export const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-[#FBFAF6]">
      <Navbar />
      <main id="main" className="flex-1 pt-20" data-testid="site-main">
        {children}
      </main>
      <Footer />
    </div>
  );
};
